export const Routes = {
  GALLERY: '/exclusives/gallery',
  ROOT: '/exclusives',
};
